module.exports = __webpack_public_path__ + "static/avatar-rashko2-f57c3fda014efc6378bdd625b22a6adf.jpg";